import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'summit:outcomes-sunburst',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'summit.outcomes-sunburst',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 300,
          },
        ],
      },
    },
    description: 'Summit Outcomes Page (Sunburst)',
    name: 'summit.outcomes.flat',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
